export const ctaButtonClicked = (position, href, ctaText, headerText = '') => ({
  type: 'CTA Button Clicked',
  data: {
    cta_position: position,
    url: href,
    cta_text: ctaText,
    component_heading: headerText,
  },
});
